import React, { useState } from 'react';
import "../css/GuiaUso.css";
import { Button } from '@mui/material';
import imgGuiaSol from "../logos/guia_solicitar.jpg";
import imgGuiaGes from "../logos/guia_gestion.jpg";

function GuiaUso() {

  const [datosTurno, setDatosTurno] = useState({dni: 0, email: ""})
  
  
  return (
    <>
        <p className='lobby-titulo'>Guía de uso</p>
        <br/>
        <div className='explicacion-box'>

            <p className='titulo'>  ¿Cómo solicitar un nuevo turno? </p>
            <p className='parrafos'>Ahora solicitar un nuevo turno para realizar trámites en la municipalidad es más fácil, rápido y lo puedes hacer desde cualquier dispositivo con una conexión a internet.</p>
            <p className='parrafos'>Para Solicitar un nuevo turno, ingrese a la página principal de la aplicación y seleccione <b>Solicitar turno.</b> </p>
            <p className='parrafos'>Siga el paso a paso del formulario completando los datos solicitados.</p>
            <img src={imgGuiaSol} className='uso-imagen' />

        </div>

        <div className='explicacion-box'>

            <p className='titulo'>  ¿Cómo consultar un turno? </p>
            <p className='parrafos'>Si necesitas consultar un turno existente, el nuevo sistema de gestión de turnos del Municipio Vicente López le permite acceder al sistema para consultar la fecha, hora y lugar a donde debe acudir para realizar su trámite.</p>
            <p className='parrafos'>Para consultar un turno, ingrese a la página principal de la aplicación y seleccione <b>Gestionar turno.</b> </p>
            <img src={imgGuiaGes} className='uso-imagen' />

        </div>
    </>
  );
}

export default GuiaUso;
